/**
 * XinYuanMobileCha  移动实体
 * zxw 
 * 2025-03-14 
 */

import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import cookie from 'react-cookies';
import {
    Sender, Suggestion, useXChat,
    useXAgent, Bubble, XStream, Welcome
} from '@ant-design/x';
import {
    Button, message, theme,
    Space, Typography, Flex,
    Popover, Select, Image
} from 'antd';
import {
    UserOutlined,
    PlusOutlined,
    CopyOutlined,
    EnterOutlined,
    LineChartOutlined,
    ProfileOutlined,
    AppstoreOutlined,
    FolderOutlined,
    FileMarkdownOutlined,
    FolderViewOutlined,
    GlobalOutlined,
} from '@ant-design/icons';
import {
    QuantityRequirementIcon,
    HybridQueryIcon,
    WOIcon,
    SupplierIcon,
    IntersectionIcon,
} from '../../incs/Icons';
import markdownit from 'markdown-it';
import {
    AddRequestHeaders,
    winHeight,
    ToScrollBottom,
    isGTscreenWidth,
    ClearMarkdown,
    rootReactDom,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

import { renderNetworkData } from './FunNetworkData';

import CommandX from './CommandX';
import AssistantBoxView from './AssistantBoxView';

const newMessage = message;

const CHATsuggestions = [    //  chat
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '搜索下关羽败走麦城的根本原因，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '搜索下关羽败走麦城的根本原因，请使用百度搜索引擎。',
    },
];

const SEALsuggestions = [    //  账户
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下软件研发部部有哪些人，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下软件研发部，研发工程师这个岗位有哪些人？以表格形式展示。',
    },
    {
        label: '账户管理',
        value: 'user',
        icon: <UserOutlined />,
        children: [
            {
                label: '查询账户',
                value: '查下lisi这个账户信息',
            },
            {
                label: '查询电话',
                value: '查下电话18107450001的账户信息',
            },
            {
                label: '查询邮箱',
                value: '查下邮箱lisi@qq.com的账户信息',
            },
            {
                label: '禁用账户',
                value: '禁用lisi这个账户',
            },
        ]
    },
    {
        label: '报表管理',
        value: 'report',
        icon: <LineChartOutlined />,
        children: [
            {
                label: '查询报表类型',
                value: '查下能力类型分类占比这份报表信息',
            },
            {
                label: '查询时间跨度',
                value: '查下每日活跃用户报表在60天以内情况',
            },
        ]
    },
];

const PLMSsuggestions = [    //  项目
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下工单等级为3级有哪些？3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下工单等级为3级，类型为硬件的有哪些？',
    },
    {
        label: '工单管理',
        value: 'wo',
        icon: <WOIcon />,
        children: [
            {
                label: '编号查询',
                value: '查下工单编号为202502110001的信息',
            },
            {
                label: '类型查询',
                value: '查下工单类型为硬件的有哪些？',
            },
            {
                label: '时段查询',
                value: '查下2025年2月1日到2025年2月28日的工单有哪些？',
            },
            {
                label: '禁用工单',
                value: '禁用编号为202502110001的工单',
            },
        ]
    },
];

const SCMSsuggestions = [   //  供应链
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下供应产品类别为家具的供应商有哪些，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下主要供应产品是交换机，品牌是华为的供应商有哪些？',
    },
    {
        label: '供应管理',
        value: 'supplier',
        icon: <SupplierIcon />,
        children: [
            {
                label: '供应商名称查询',
                value: '查下新致腾这家供应商的信息',
            },
            {
                label: '供应商品牌查询',
                value: '查下能提供华为这个品牌的供应商有哪些？',
            },
            {
                label: '供应产品类别查询',
                value: '查下供应产品类别为家具的供应商有哪些？',
            },
            {
                label: '主要供应产品查询',
                value: '查下主要供应产品为交换机的供应商有哪些？',
            },
        ]
    },
    {
        label: '产品管理',
        value: 'product',
        icon: <ProfileOutlined />,
        children: [
            {
                label: '名称查询',
                value: '查下笔记本电脑这个产品',
            },
            {
                label: '编码查询',
                value: '查下编码为X001020200001的产品',
            },
        ]
    },
    {
        label: '库存管理',
        value: 'inventory',
        icon: <AppstoreOutlined />,
        children: [
            {
                label: '名称查询',
                value: '查下笔记本电脑这个产品的库存',
            },
            {
                label: '编码查询',
                value: '查下编码为X001020200001产品的库存',
            },
        ]
    },
];

const CFMSsuggestions = [   //  云网盘
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查找名称带有公司简介的文件有哪些，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下名称带有公司简介，类型是图标的文件有哪些？',
    },
    {
        label: '查找文件',
        icon: <FolderOutlined />,
        children: [
            {
                label: '名称查询',
                value: '查找下公司简介这份文件',
            },
            {
                label: '类型查询',
                value: '查找下类型为文档的文件',
            },
        ]
    }
];

const TEIIsuggestions = [    //  交通
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下湖天大道这条路上有多少个路口，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下湖天大道这条路上的路口，且路口类型是十字路口，以表格形式展示。',
    },
    {
        label: '路口管理',
        value: 'intersection',
        icon: <IntersectionIcon />,
        children: [
            {
                label: '查询路口',
                value: '查下房产局这个路口信息',
            },
            {
                label: '查询配时',
                value: '查下房产局这个路口的配时信息',
            },
        ]
    },
    {
        label: '报表管理',
        value: 'report',
        icon: <LineChartOutlined />,
        children: [
            {
                label: '查询报表类型',
                value: '查下路口主机分类占比这份报表信息',
            },
        ]
    },
];

const getSuggestions = (service) => {
    switch (service) {
        case 'seal':
            return SEALsuggestions;
        case 'plms':
            return PLMSsuggestions;
        case 'scms':
            return SCMSsuggestions;
        case 'cfms':
            return CFMSsuggestions;
        case 'teii':
            return TEIIsuggestions;
        default:
            return CHATsuggestions;
    }
}

const getPutOutFunctionName = () => {
    //  以下的函数名，需要展示大模型的输出
    return [
        'chat_network_crawler',
        'chat_network_search',
        'chat_network_news',
        'chat_network_hots',
    ]
}

const md = markdownit({
    html: true,
    breaks: true,
});

const XinYuanMobileChatX = (props) => {
    const newProps = useRef(null);
    const projectCode = useRef(CNF.projectCode);        //  项目代码，默认使用系统本身

    const loading = useRef(false);  //  加载状态
    const [content, setContent] = useState('');         //  当前输入内容
    const [hoverId, setHoverId] = useState('');         //  鼠标悬浮ID

    const { token } = theme.useToken();
    const abortRef = useRef(() => { });
    const senderRef = useRef(null);                     //  输入框高亮

    const service = useRef('');                         //  选择服务，默认选择账户服务
    const isNetwork = useRef(0);                        //  是否联网

    const networkData = useRef([]);                     //  网络数据，通过大模型工具匹配调用接口的返回数据
    const conversationMessages = useRef([]);            //  会话数据

    const [isCommand, setIsCommand] = useState(false);  //  是否通过输入‘/’调用指令
    const [isHover, setIsHover] = useState(false);      //  是否悬浮
    const [publicCommandInfo, setPublicCommandInfo] = useState({});     //  指令库指令Ulid，使用指令库时赋值

    const dialogueUlid = useRef('');        //  对话Ulid
    const conversationId = useRef('');      //  会话ID

    /**
     * 初始化
     */
    const initialize = () => {
        setMessages([]);
        conversationId.current = '';
        dialogueUlid.current = '';
        networkData.current = [];
        conversationMessages.current = [];
        // setContent(''); //  情况输入框
        loading.current = false;
    }

    /**
     * 请求暂停
     */
    useEffect(() => {
        return () => {
            abortRef.current();
        };
    }, []);

    /**
     * 输入“/”
     */
    useEffect(() => {
        //  调用指令
        if (content === '/') {
            setIsCommand(true);
        }
        //  撤销指令
        if (!content) {
            setIsCommand(false);
        }
        //  如果输入的第一个字符为“/”，则表示调用指令，之后的字符作为指令内容搜索的关键字
        if (content && content.charAt(0) === '/') {
            setCommandContentKeys(content.slice(1))
        }
    }, [content]);

    /**
     * 打开历史会话
     */
    useEffect(() => {
        //  初始化历史对话内容
        if (props.messages.length > 0) {
            let ms = [];    //  重新组装会话数组
            for (let i = 0; i < props.messages.length; i++) {
                let item = props.messages[i];
                ms.push({
                    id: i,
                    message: item.content,
                    status: item.role === 'user' ? 'local' : 'ai'
                });
                if (item.network_data_type && item.network_data_list.length > 0) {
                    let newNetworkData = networkData.current;
                    newNetworkData.push({
                        id: i,
                        type: item.network_data_type,    //  数据类型
                        mod: item.network_data_mod,      //  报表模块
                        data: item.network_data_list,    //  报表数据
                    });
                    networkData.current = newNetworkData;
                } else {
                    networkData.current = [];
                }
            }
            setMessages(ms);
            conversationMessages.current = props.messages;
            conversationId.current = props.conversationId;
            dialogueUlid.current = props.dialogueUlid;
        } else {
            setMessages([]);
            conversationMessages.current = [];
            conversationId.current = '';
            dialogueUlid.current = '';
        }
        setTimeout(() => {
            ToScrollBottom('xinyuan-chat-id');
        }, 100);
        newProps.current = props;
    }, [props]);

    /**
     * 新建对话
     */
    useEffect(() => {
        initialize();
    }, [props.newSessionTag]);

    /**
     * 与后端模型进行交互，提供抽象数据流。
     */
    const [agent] = useXAgent({
        request: async ({ message }, { onSuccess, onUpdate }) => {
            let newconversationMessages = conversationMessages.current;
            newconversationMessages.push({
                role: 'user',
                content: message.content,
            });
            conversationMessages.current = newconversationMessages; //  更新会话数据
            //  若是使用指令库指令，则增加指令调用数
            if (publicCommandInfo && publicCommandInfo.key) {
                addPublicCommandUseCount();
            }
            try {
                //  请求
                const response = await fetch(CNF.onaiApi + (service.current ? 'xinyuan/completions' : 'completions'),
                    {
                        method: 'POST',
                        headers: AddRequestHeaders(),
                        dataType: 'JSON',
                        body: JSON.stringify({
                            project_code: service.current ? service.current.toLocaleLowerCase() : projectCode.current.toLocaleLowerCase(),
                            conversation_id: message.conversationId,
                            is_network: isNetwork.current,
                            model: newProps.current.model.value,
                            version_id: newProps.current.versionInfo.value,
                            stream: 1,
                            messages: conversationMessages.current,
                            temperature: newProps.current.temperature,
                            top_p: newProps.current.topP,
                            max_tokens: newProps.current.versionInfo.max_tokens,
                        }),
                        // signal: ctrl.signal,
                        openWhenHidden: true,
                    });
                if (response.ok && response.status === 200) {
                    //  连接成功
                } else {
                    //  连接失败
                    onUpdate('很抱歉，系统繁忙，暂时无法处理您的需求！');
                    abortRef.current();
                    loading.current = false;
                }
                const td = new TextDecoder('utf-8');

                //  将 ReadableStream 解码并读取
                const stream = XStream({
                    readableStream: new ReadableStream({
                        async start(controller) {
                            const r = response.body.getReader()
                            while (r) {
                                const { done, value } = await r.read();
                                if (done) break;
                                const text = td.decode(value, { stream: true });
                                await new Promise((resolve) => setTimeout(resolve, 300));
                                controller.enqueue(new TextEncoder().encode(text));
                            }
                            controller.close();
                        },
                    })
                });

                const reader = stream.getReader();
                //  停止读流
                abortRef.current = () => {
                    reader?.cancel();
                };

                let currentRequestId = ''   //  当前请求Id
                let currentContent = '';    //  当前返回内容
                let networkDataType = '';   //  网络数据类型，通过大模型工具匹配调用接口的方法名称，有搜索引擎，也有系统接口
                let networkDataMod = '';    //  网络数据模块，通过大模型工具匹配调用接口的方法名称，对应的模块。
                let networkDataList = ''    //  网络数据列表，通过大模型工具匹配调用接口的返回数据
                //  循环读出流数据
                while (reader) {
                    const { value, done } = await reader.read();
                    //  读取完成
                    if (done) {
                        onSuccess(currentContent);
                        let newconversationMessages = conversationMessages.current;
                        newconversationMessages.push({
                            role: 'assistant',
                            content: currentContent
                        });
                        conversationMessages.current = newconversationMessages; // 更新会话数据
                        createDialogueContent('assistant', currentContent,
                            dialogueUlid.current,
                            conversationId.current,
                            currentRequestId,
                            networkDataType,
                            networkDataMod,
                            networkDataList
                        );
                        loading.current = false;  //  关闭加载中
                        break;
                    }
                    if (!value) continue;
                    const data = JSON.parse(value.data);
                    if (data.network_data_type) {    //  系统数据，需要在前端展示
                        networkDataType = data.network_data_type;
                        networkDataMod = data.network_data_mod;
                        networkDataList = data.result;
                        let newNetworkData = networkData.current;
                        newNetworkData.push({
                            id: conversationMessages.current.length,
                            type: data.network_data_type,    //  数据类型
                            mod: data.network_data_mod,      //  数据模块
                            data: data.result,               //  报表数据
                        }
                        );
                        networkData.current = newNetworkData;  //  更新网络数据
                    } else {
                        currentContent += data.result || '';
                        currentRequestId = data.id
                        onUpdate(currentContent);
                    }
                    loading.current = false;  //  关闭加载中，开始进行流式输出
                    ToScrollBottom('xinyuan-chat-id');
                }
            } catch (e) {
                //  异常
                onUpdate('很抱歉，系统异常，暂时无法处理您的需求！');
                abortRef.current();
                loading.current = false;
            }
        },
    });

    // Chat messages
    const { onRequest, setMessages, messages, } = useXChat({
        agent,
    });

    /**
     * 查看内容
     * @param {*} content 
     */
    const viewContent = (content, index) => {
        rootReactDom && rootReactDom.render(
            <AssistantBoxView
                preGroup={props.preGroup}
                isModalOpen={true}
                senderRef={senderRef}
                content={content}
                index={index}
                networkData={networkData.current}
            />);
    }

    /**
     * 创建会话
     * @param {*} role 
     * @param {*} content 
     */
    const createDialogue = (role, content) => {
        $.ajax({
            url: `${CNF.api}dialogues`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'project_code': service.current ? service.current : projectCode.current,
                'model': newProps.current.model.value,
                'version': newProps.current.versionInfo.value,
                'title': content.split('\n')[0].slice(0, 50),
            }), success: function (data) {
                if (data.res === 0) {
                    dialogueUlid.current = data.dat.dialogue_ulid;
                    conversationId.current = data.dat.conversation_id;
                    onRequest({
                        content: content,
                        conversationId: data.dat.conversation_id
                    });
                    //  创建用户内容，用户对话内容联网数据为空
                    createDialogueContent(role, content, data.dat.dialogue_ulid, data.dat.conversation_id);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 创建会话内容
     * @param {*} role 
     * @param {*} content 
     * @param {*} dialogueUlid 
     * @param {*} conversationId 
     * @param {*} requestId 
     * @param {*} networkDataType 
     * @param {*} networkDataList 
     * @returns 
     */
    const createDialogueContent = (role, content,
        _dialogueUlid = '',
        _conversationId = '',
        requestId = '',
        networkDataType = '',
        networkDataMod = '',
        networkDataList = ''
    ) => {
        //  参数校验
        if (content === '') {
            return;
        }
        $.ajax({
            url: `${CNF.api}dialogue/contents`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'dialogue_ulid': _dialogueUlid,
                'conversation_id': _conversationId,
                'request_id': requestId,
                'role': role,
                'content': content,
                'network_data_type': networkDataType,
                'network_data_mod': networkDataMod,
                'network_data_list': networkDataList ? networkDataList : '',
            }), success: function (data) {
                if (data.res === 0) {
                    // message.success(data.msg, 1);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 添加指令调用次数
     */
    const addPublicCommandUseCount = () => {
        $.ajax({
            url: `${CNF.api}command/publics/${publicCommandInfo.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'action': 'ADDUSECOUNT',
                'title': publicCommandInfo.title
            }), success: function (data) {
                if (data.res === 0) {
                    //  增加成功，清空指令库指令
                    setPublicCommandInfo({});
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    //  布局相关
    const [commandContentKeys, setCommandContentKeys] = useState('');   //  指令搜索关键字

    //  自定义sender组件头部
    const senderHeaderNode = (<Sender.Header open={isCommand} closable={false}
        style={{ background: '#fff', borderRadius: '12px 12px 0 0' }}>
        <Flex
            vertical
            align='left'
            gap='small'
        >
            <CommandX
                senderRef={senderRef}
                setMessages={setContent}    //  更新输入框内容，为了兼顾之前的老版本
                setIsCommand={setIsCommand}
                setIsHover={setIsHover}
                setPublicCommandInfo={setPublicCommandInfo}
                commandContentKeys={commandContentKeys}
            />
        </Flex>
    </Sender.Header>
    )

    return <div style={{
        height: winHeight - 124,
        position: 'relative',
        border: '0px solid red',
        width: isGTscreenWidth ? (props.isOpenHistory ? '70%' : '60%') : (props.isOpenHistory ? '80%' : '70%'),
        marginLeft: isGTscreenWidth ? (props.isOpenHistory ? '15%' : '20%') : (props.isOpenHistory ? '10%' : '15%'),
    }}>
        <div id='xinyuan-chat-id' style={{
            height: winHeight - 264,
            scrollbarColor: '#d9d9d9 transparent',
            scrollbarWidth: 'thin',
            overflowY: 'auto',
            paddingTop: 45,
        }}>
            {
                //  欢迎组件
                loading.current || conversationMessages.current.length > 0 ? null : <Welcome
                    styles={{
                        title: { fontSize: 18 },
                        icon: { fontSize: 15 }
                    }}
                    icon={<Image height={40} style={{ borderRadius: 15, }} src={props.model.logo} preview={false} />}
                    variant='borderless'
                    title={'你好，我是' + props.model.value + '！'}
                    description={props.model.prompt}
                />
            }
            {
                //  内容输出
                messages && messages.map(({ id, message, status }, index) => {
                    let isLocal = status === 'local' ? true : false;
                    return (
                        <Bubble
                            key={id}
                            style={{
                                marginBottom: 10,
                                marginRight: 10,
                            }}
                            styles={{
                                content: {
                                    background: isLocal ? CNF.themeColors[0] : '#fff',
                                }
                            }}
                            variant='filled'
                            placement={isLocal ? 'end' : 'start'}
                            avatar={
                                isLocal ? {
                                    icon: cookie.load(CNF.cookies.keyAvatarUrl) ? <Image height={40} style={{ borderRadius: 15, }} src={CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl)} preview={false} /> : <UserOutlined />,
                                    style: {
                                        background: cookie.load(CNF.cookies.keyAvatarUrl) ? '#fff' : CNF.themeColors[1],
                                    },
                                } : {
                                    icon: <Image height={40} style={{ borderRadius: 15, }} src={props.model.logo} preview={false} />,
                                    style: {
                                        background: '#fff',
                                    },
                                }
                            }
                            content={message.content || message}
                            messageRender={(content) => {
                                let currentNetworkData = networkData.current;
                                let networkDataItem = currentNetworkData && currentNetworkData.find(item => item.id === index);
                                return <>
                                    {   //  渲染联网数据
                                        networkDataItem ? renderNetworkData(networkDataItem, false, '') : ''
                                    }
                                    <Typography.Text style={{ color: isLocal ? '#fff' : '' }}>
                                        <div className='chat-markdown-it' style={{ margin: '-10px 0', }}
                                            dangerouslySetInnerHTML={{
                                                //  部分返方法返回的数据，不需要在前端输出
                                                __html: md.render(networkDataItem && !getPutOutFunctionName().includes(networkDataItem.type) ? '' : content),
                                            }}
                                        />
                                    </Typography.Text>
                                </>
                            }}
                            typing={isLocal || (index <= props.messages.length) ? false : {
                                step: 2,
                                interval: 50,
                            }}
                            onMouseEnter={() => { setHoverId(index); }}
                            onMouseLeave={() => { setHoverId(''); }}
                            footer={
                                isLocal ? <div style={{ visibility: hoverId === index ? 'visible' : 'hidden' }}>
                                    <Space size={token.paddingXXS}>
                                        <Popover placement='top' content='复制'>
                                            <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<CopyOutlined />}
                                                onClick={() => {
                                                    if (navigator.clipboard && window.isSecureContext) {
                                                        navigator.clipboard.writeText(message.content || message).then(() => {
                                                            //  复制成功
                                                            newMessage.success('复制成功！', CNF.messageDuration);
                                                        }).catch((error) => {
                                                            //  复制失败
                                                            newMessage.error(error, CNF.messageDuration);
                                                        })
                                                    } else {
                                                        const input = document.createElement('textarea');
                                                        input.value = message.content || message;
                                                        document.body.appendChild(input);
                                                        input.select();
                                                        document.execCommand('copy');
                                                        document.body.removeChild(input);
                                                        newMessage.success('复制成功！', CNF.messageDuration);
                                                    }
                                                }}
                                            />
                                        </Popover>
                                        <Popover placement='top' content='引用'>
                                            <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<EnterOutlined />}
                                                onClick={() => {
                                                    setContent(message.content || message);
                                                }}
                                            />
                                        </Popover>
                                    </Space>
                                </div>
                                    :
                                    //  AI气泡框，当鼠标悬浮，或者最后一个输出显示按钮
                                    <div style={{ visibility: (hoverId === index || index === conversationMessages.current.length - 1) ? 'visible' : 'hidden' }}>
                                        <Space size={token.paddingXXS}>
                                            <Popover placement='top' content='查看内容'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<FolderViewOutlined />}
                                                    onClick={() => {
                                                        viewContent(message, index);
                                                    }}
                                                />
                                            </Popover>
                                            <Popover placement='top' content='复制成Markdown'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<FileMarkdownOutlined />}
                                                    onClick={() => {
                                                        if (navigator.clipboard && window.isSecureContext) {
                                                            navigator.clipboard.writeText(message).then(() => {
                                                                // 复制成功
                                                                newMessage.success('复制成功！', CNF.messageDuration);
                                                            }).catch((error) => {
                                                                // 复制失败
                                                                newMessage.error(error, CNF.messageDuration);
                                                            })
                                                        } else {
                                                            const input = document.createElement('textarea');
                                                            input.value = message;
                                                            document.body.appendChild(input);
                                                            input.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(input);
                                                            newMessage.success('复制成功！', CNF.messageDuration);
                                                        }
                                                    }}
                                                />
                                            </Popover>
                                            <Popover placement='top' content='复制内容'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<CopyOutlined />}
                                                    onClick={() => {
                                                        if (navigator.clipboard && window.isSecureContext) {
                                                            navigator.clipboard.writeText(ClearMarkdown(message)).then(() => {
                                                                // 复制成功
                                                                newMessage.success('复制成功！', CNF.messageDuration);
                                                            }).catch((error) => {
                                                                // 复制失败
                                                                newMessage.error(error, CNF.messageDuration);
                                                            })
                                                        } else {
                                                            const input = document.createElement('textarea');
                                                            input.value = ClearMarkdown(message);
                                                            document.body.appendChild(input);
                                                            input.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(input);
                                                            newMessage.success('复制成功！', CNF.messageDuration);
                                                        }
                                                    }}
                                                />
                                            </Popover>
                                            {/* <Popover placement='top' title={null} color='#000' content={<span style={{ color: '#fff' }}>重新生成</span>}>
                                            <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<SyncOutlined />} />
                                        </Popover> */}
                                        </Space>
                                    </div>
                            }
                        />
                    )
                })
            }
            {
                //  请求加载
                loading.current ? <Bubble
                    style={{
                        marginBottom: 15,
                    }}
                    placement='start'
                    avatar={{
                        icon: <Image height={40} style={{ borderRadius: 15, }} src={props.model.logo} preview={false} />,
                        style: {
                            background: '#fff',
                            // borderColor: '#F0F0F0',
                        },
                    }}
                    loading={true}
                /> : null
            }

        </div>
        <div style={{ position: 'absolute', width: '100%', bottom: 5, }}>
            <Suggestion
                items={getSuggestions(service.current)}
                onSelect={(nextContent) => {
                    setContent(nextContent);
                }}
            >
                {({ onTrigger, onKeyDown }) => {
                    return (
                        <Flex wrap gap={12}>
                            <Button icon={<PlusOutlined />}
                                onClick={() => {
                                    initialize();
                                }}
                            >新建会话</Button>
                            {
                                ['deepseek', 'moonshot-v1', 'doubao', '星火'].includes(props.model.value) ? (
                                    <Button color={isNetwork.current ? 'primary' : 'default'} variant='outlined' icon={<GlobalOutlined />}
                                        onClick={() => {
                                            isNetwork.current = isNetwork.current ? 0 : 1;
                                            setIsHover(!isHover);  //  触发渲染用，无其它用途。
                                        }}
                                    >联网搜索</Button>
                                ) : ''
                            }
                            {
                                ['deepseek', 'moonshot-v1', 'doubao'].includes(props.model.value) && props.services && props.services.length > 0 ? (
                                    <Select
                                        placeholder='选择服务'
                                        onChange={(value) => {
                                            service.current = value;
                                            props.changeService(value); //  切换服务，用于检索历史对话
                                        }}
                                        allowClear
                                        showSearch
                                        style={{ width: 110 }}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={props.services.map((item) => {
                                            return {
                                                value: item.value,
                                                label: item.key,
                                            }
                                        })}
                                    />
                                ) : null
                            }
                            <Sender
                                placeholder='输入“/”创建和收藏指令，回车换行'
                                loading={agent.isRequesting()}
                                value={content}
                                submitType='shiftEnter'
                                header={senderHeaderNode}
                                ref={senderRef}     //  用户获取焦点
                                allowSpeech
                                style={{
                                    background: '#fff',
                                    // border: 1,
                                }}
                                actions={(_, info) => {
                                    const { SendButton, LoadingButton, ClearButton } = info.components;
                                    return (
                                        <Space size="small">
                                            <Popover placement='top' content='清空内容'>
                                                <ClearButton />
                                            </Popover>
                                            {agent.isRequesting() ? (
                                                <LoadingButton type='default' />
                                            ) : (
                                                <Popover placement='top' content='请输入你的问题'>
                                                    <SendButton type='primary' />
                                                </Popover>
                                            )}
                                        </Space>
                                    );
                                }}
                                onChange={(nextContent) => {
                                    if (nextContent === '?' || nextContent === '？') {  //  弹出建议
                                        onTrigger();
                                    } else if (!nextContent) {
                                        onTrigger(false);
                                    }
                                    setContent(nextContent);
                                }}
                                onSubmit={(nextContent) => {
                                    if (conversationId.current) { //  对话已存在
                                        createDialogueContent('user', nextContent, dialogueUlid.current, conversationId.current);
                                        onRequest({
                                            content: nextContent,
                                            conversationId: conversationId.current
                                        });
                                    } else {
                                        createDialogue('user', nextContent);
                                    }
                                    setContent('');
                                    ToScrollBottom('xinyuan-chat-id');
                                    loading.current = true;
                                }}
                                onCancel={() => {
                                    abortRef.current();
                                    // loading.current = false;
                                    if (!agent.isRequesting()) loading.current = false;   //  正在请求不能中断输出
                                }}
                                onKeyDown={onKeyDown}
                            />
                        </Flex>
                    );
                }}
            </Suggestion>
        </div>
    </div>
}

export default XinYuanMobileChatX;